import { render, staticRenderFns } from "./PersonalizeProfile.vue?vue&type=template&id=6706e29d&scoped=true&"
import script from "./PersonalizeProfile.vue?vue&type=script&lang=js&"
export * from "./PersonalizeProfile.vue?vue&type=script&lang=js&"
import style0 from "./PersonalizeProfile.vue?vue&type=style&index=0&id=6706e29d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6706e29d",
  null
  
)

export default component.exports